import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const ServiceProcessSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const processSteps = [
    {
      number: '01',
      title: language === 'fr' ? 'Consultation initiale' : 
             language === 'ar' ? 'استشارة أولية' : 
             'Initial consultation',
      description: language === 'fr' 
        ? 'Nous commençons par une consultation approfondie pour comprendre vos besoins spécifiques et les défis de votre industrie.' 
        : language === 'ar' 
        ? 'نبدأ باستشارة شاملة لفهم احتياجاتك المحددة وتحديات صناعتك.' 
        : 'We begin with a thorough consultation to understand your specific needs and industry challenges.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      )
    },
    {
      number: '02',
      title: language === 'fr' ? 'Évaluation technique' : 
             language === 'ar' ? 'تقييم فني' : 
             'Technical assessment',
      description: language === 'fr' 
        ? 'Nos experts effectuent une évaluation technique détaillée de vos systèmes existants ou de vos besoins en nouveaux équipements.' 
        : language === 'ar' 
        ? 'يقوم خبراؤنا بإجراء تقييم فني مفصل لأنظمتك الحالية أو احتياجاتك من المعدات الجديدة.' 
        : 'Our experts conduct a detailed technical assessment of your existing systems or new equipment needs.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      )
    },
    {
      number: '03',
      title: language === 'fr' ? 'Proposition de solution' : 
             language === 'ar' ? 'اقتراح الحل' : 
             'Solution proposal',
      description: language === 'fr' 
        ? 'Nous développons une solution personnalisée adaptée à vos besoins spécifiques, comprenant des recommandations détaillées et un devis transparent.' 
        : language === 'ar' 
        ? 'نطور حلاً مخصصًا يناسب احتياجاتك المحددة، بما في ذلك توصيات مفصلة وعرض أسعار شفاف.' 
        : 'We develop a customized solution tailored to your specific needs, including detailed recommendations and a transparent quote.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    },
    {
      number: '04',
      title: language === 'fr' ? 'Mise en œuvre' : 
             language === 'ar' ? 'التنفيذ' : 
             'Implementation',
      description: language === 'fr' 
                ? 'Notre équipe certifiée met en œuvre la solution avec une attention méticuleuse aux détails et aux normes de sécurité les plus strictes.'
        : language === 'ar' 
        ? 'يقوم فريقنا المعتمد بتنفيذ الحل مع الاهتمام الدقيق بالتفاصيل وأعلى معايير السلامة.'
        : 'Our certified team implements the solution with meticulous attention to detail and the strictest safety standards.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      number: '05',
      title: language === 'fr' ? 'Tests et validation' : 
             language === 'ar' ? 'الاختبار والتحقق' : 
             'Testing and validation',
      description: language === 'fr' 
        ? 'Nous effectuons des tests rigoureux pour garantir que tous les systèmes fonctionnent selon les spécifications et répondent aux normes de l\'industrie.' 
        : language === 'ar' 
        ? 'نجري اختبارات صارمة لضمان أن جميع الأنظمة تعمل وفقًا للمواصفات وتلبي معايير الصناعة.' 
        : 'We conduct rigorous testing to ensure all systems are operating to specification and meeting industry standards.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      number: '06',
      title: language === 'fr' ? 'Formation et transfert de connaissances' : 
             language === 'ar' ? 'التدريب ونقل المعرفة' : 
             'Training and knowledge transfer',
      description: language === 'fr' 
        ? 'Nous formons votre équipe à l\'utilisation et à la maintenance des systèmes, en assurant un transfert complet des connaissances.' 
        : language === 'ar' 
        ? 'ندرب فريقك على استخدام الأنظمة وصيانتها، مما يضمن نقلاً كاملاً للمعرفة.' 
        : 'We train your team on system operation and maintenance, ensuring complete knowledge transfer.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    },
    {
      number: '07',
      title: language === 'fr' ? 'Support continu' : 
             language === 'ar' ? 'الدعم المستمر' : 
             'Ongoing support',
      description: language === 'fr' 
        ? 'Nous offrons un support technique continu 24/7 et des services de maintenance réguliers pour assurer la performance optimale de vos systèmes.' 
        : language === 'ar' 
        ? 'نقدم دعمًا فنيًا مستمرًا على مدار الساعة طوال أيام الأسبوع وخدمات صيانة منتظمة لضمان الأداء الأمثل لأنظمتك.' 
        : 'We provide ongoing 24/7 technical support and regular maintenance services to ensure optimal system performance.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
        </svg>
      )
    }
  ];

  return (
    <section className="section section-light" style={{ 
      position: 'relative',
      overflow: 'hidden',
      padding: '6rem 0 8rem'
    }}>
      {/* Decorative elements */}
      <div className="blob" style={{ 
        top: '-20%', 
        right: '-10%', 
        opacity: 0.07,
        animation: 'blob-animation 35s linear infinite'
      }}></div>
      <div className="blob" style={{ 
        bottom: '-30%', 
        left: '-15%', 
        opacity: 0.05,
        animation: 'blob-animation 30s linear infinite reverse'
      }}></div>
      
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '40% 60% 60% 40% / 60% 30% 70% 40%',
        background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0) 100%)',
        animation: 'float 12s ease-in-out infinite',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '15%',
        right: '8%',
        width: '160px',
        height: '160px',
        borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
        background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0) 100%)',
        animation: 'float 10s ease-in-out infinite reverse',
        animationDelay: '2s',
        zIndex: 1
      }}></div>
      
      <div className="bg-pattern" style={{ opacity: 0.03 }}></div>
      
      <div className="container" style={{ 
        position: 'relative', 
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '4rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: '0.5rem 1.5rem',
            backgroundColor: 'rgba(255, 107, 0, 0.15)',
            color: 'var(--assco-orange)',
            borderRadius: '30px',
            fontWeight: '600',
            fontSize: '0.875rem',
            marginBottom: '1rem',
            textTransform: 'uppercase'
          }}>
            {language === 'fr' ? 'NOTRE PROCESSUS' : 
             language === 'ar' ? 'عمليتنا' : 
             'OUR PROCESS'}
          </span>
          
          <h2 className="fade-in" style={{ 
            fontSize: '2.75rem', 
            marginBottom: '1.5rem',
            position: 'relative',
            paddingBottom: '1.5rem',
            color: '#1a202c',
            fontWeight: '700',
            display: 'inline-block'
          }}>
            {t('services.process.title')}
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          
          <p className="subtitle fade-in" style={{ 
            maxWidth: '800px',
            margin: '0 auto 5rem',
            fontSize: '1.25rem',
            color: '#4a5568',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Notre processus de service éprouvé garantit des résultats cohérents et de haute qualité pour tous vos besoins en instrumentation.' 
              : language === 'ar'
              ? 'تضمن عملية الخدمة المثبتة لدينا نتائج متسقة وعالية الجودة لجميع احتياجات القياس الخاصة بك.'
              : 'Our proven service process ensures consistent, high-quality results for all your instrumentation needs.'}
          </p>
        </div>
        
        <div className="process-timeline" style={{ position: 'relative' }}>
          {/* Timeline connector */}
          <div style={{
            position: 'absolute',
            top: '75px',
            left: '0',
            right: '0',
            height: '4px',
            background: 'linear-gradient(90deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0.3) 50%, rgba(255, 107, 0, 0.1) 100%)',
            borderRadius: '4px',
            zIndex: 1
          }}></div>
          
          {/* Progress marker - animated */}
          <div style={{
            position: 'absolute',
            top: '67px',
            left: '0',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: 'var(--assco-orange)',
            boxShadow: '0 0 20px rgba(255, 107, 0, 0.8)',
            zIndex: 3,
            animation: 'timeline-progress 15s linear infinite'
          }}></div>
          
          <div className="grid" style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: '1.5rem',
            position: 'relative',
            zIndex: 2,
            maxWidth: '1600px',
            margin: '0 auto'
          }}>
            {processSteps.map((step, index) => (
              <div 
                key={index}
                className="process-step fade-in"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  animationDelay: `${0.2 * index}s`
                }}
              >
                <div style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '25px',
                  backgroundColor: 'rgba(255, 107, 0, 0.08)',
                  backdropFilter: 'blur(10px)',
                  border: '2px solid rgba(255, 107, 0, 0.15)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '3rem',
                  position: 'relative',
                  boxShadow: '0 8px 25px rgba(255, 107, 0, 0.1)',
                  transform: 'rotate(-2deg)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-6px) rotate(0deg) scale(1.03)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(255, 107, 0, 0.2)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'rotate(-2deg) scale(1)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 107, 0, 0.1)';
                }}>
                  <div style={{ 
                    width: '50px',
                    height: '50px',
                    color: 'var(--assco-orange)',
                    filter: 'drop-shadow(0 0 8px rgba(255, 107, 0, 0.5))'
                  }}>
                    {step.icon}
                  </div>
                  
                  <div style={{
                    position: 'absolute',
                    top: '-12px',
                    right: '-12px',
                    backgroundColor: 'var(--assco-orange)',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '800',
                    fontSize: '1rem',
                    boxShadow: '0 5px 15px rgba(255, 107, 0, 0.4)',
                    border: '2px solid #1a1a1a'
                  }}>
                    {step.number}
                  </div>
                  
                  {/* Connector dot */}
                  <div style={{
                    position: 'absolute',
                    bottom: '-45px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--assco-orange)',
                    border: '3px solid #1a1a1a',
                    zIndex: 3
                  }}></div>
                </div>
                
                <h3 style={{ 
                  fontSize: '1.1rem',
                  marginBottom: '1rem',
                  color: '#1a202c',
                  fontWeight: '700',
                  minHeight: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  lineHeight: '1.3'
                }}>
                  {step.title}
                </h3>
                
                <p style={{ 
                  color: '#4a5568',
                  lineHeight: '1.5',
                  fontSize: '0.9rem',
                  minHeight: '100px'
                }}>
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        
        <div style={{ 
          textAlign: 'center', 
          marginTop: '5rem',
          display: 'flex',
          justifyContent: 'center',
          width: '100%'
        }}>
          <Link 
            to="/contact"
            className="btn btn-primary"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              backgroundColor: 'var(--assco-orange)',
              color: 'white',
              padding: '1rem 2.5rem',
              borderRadius: '100px',
              border: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 10px 15px rgba(255, 107, 0, 0.3)',
              position: 'relative',
              overflow: 'hidden',
              textDecoration: 'none'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#e25a00';
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 15px 20px rgba(255, 107, 0, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 10px 15px rgba(255, 107, 0, 0.3)';
            }}
            onClick={(e) => {
              const ripple = document.createElement('span');
              ripple.classList.add('ripple');
              e.currentTarget.appendChild(ripple);
              
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;
              
              ripple.style.left = `${x}px`;
              ripple.style.top = `${y}px`;
              
              setTimeout(() => {
                ripple.remove();
              }, 600);
            }}
          >
            {language === 'fr' ? 'Commencer le processus' : 
             language === 'ar' ? 'ابدأ العملية' : 
             'Start the process'}
            <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </Link>
        </div>
      </div>
      
      {/* Shape Divider */}
      <div className="shape-divider" style={{ transform: 'rotate(180deg)' }}>
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
      </div>
      
      <style jsx>{`
        @keyframes timeline-progress {
          0% {
            left: 0%;
          }
          100% {
            left: 100%;
          }
        }
        
        .ripple {
          position: absolute;
          border-radius: 50%;
          background-color: rgba(255, 107, 0, 0.3);
          transform: scale(0);
          animation: ripple 0.6s linear;
        }
        
        @media (max-width: 1400px) {
          .grid {
            gap: 1.2rem !important;
            font-size: 0.85rem !important;
          }
          
          .process-step h3 {
            font-size: 1rem !important;
            min-height: 45px !important;
          }
          
          .process-step p {
            font-size: 0.85rem !important;
            min-height: 90px !important;
          }
        }
        
        @media (max-width: 1200px) {
          .grid {
            grid-template-columns: repeat(4, 1fr) !important;
            gap: 1.5rem !important;
          }
        }
        
        @media (max-width: 900px) {
          .grid {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 1.2rem !important;
          }
        }
        
        @media (max-width: 700px) {
          .grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 1rem !important;
          }
        }
        
        @media (max-width: 500px) {
          .grid {
            grid-template-columns: 1fr !important;
            gap: 1.5rem !important;
          }
          
          .process-step div[style*="width: 100px"] {
            width: 90px !important;
            height: 90px !important;
          }
          
          .process-step div[style*="width: 40px"][style*="height: 40px"] {
            width: 35px !important;
            height: 35px !important;
            font-size: 0.9rem !important;
          }
          
          .process-step h3 {
            font-size: 1rem !important;
            min-height: auto !important;
          }
          
          .process-step p {
            min-height: auto !important;
            font-size: 0.9rem !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ServiceProcessSection;
